import { Component } from '@angular/core';

@Component({
  selector: 'app-honeymooner',
  standalone: true,
  imports: [],
  templateUrl: './honeymooner.component.html',
  styleUrl: './honeymooner.component.scss'
})
export class HoneymoonerComponent {

}
